import { ArrowLeft } from "lucide-react";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useNavigate } from "react-router-dom";

import { airtimeApi } from "../api";

import AirtimeConfigPanel from "../components/AirtimeConfigPanel";

import AirtimeLoader from "../components/AirtimeLoader";

import { useAirtimeConfig } from "../hooks";
import { useToast } from "#/components/common/ToastProvider";

export default function AirtimeConfigPage() {

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const toast = useToast();

  const { data, isLoading } = useAirtimeConfig();

  const mutation = useMutation({

    mutationFn: airtimeApi.updateConfig,

    onSuccess: () => {

      queryClient.invalidateQueries({ queryKey: ["airtime", "config"] });

      queryClient.invalidateQueries({ queryKey: ["airtime", "stats"] });

      toast.success("Configuration updated successfully");

    },

  });

  if (isLoading) return <AirtimeLoader />;

  if (!data) return null;

  return (

    <div className="min-h-screen bg-slate-50 p-6">

      <button

        type="button"

        onClick={() => navigate("/hr/airtime")}

        className="mb-4 inline-flex items-center gap-2 text-sm font-black text-emerald-700"

      >

        <ArrowLeft className="h-4 w-4" />

        Back to Airtime Portal

      </button>

      <AirtimeConfigPanel

        config={data}

        saving={mutation.isPending}

        onSave={(payload) => mutation.mutate(payload)}

      />

    </div>

  );

}